module.exports = __webpack_public_path__ + "static/media/bookmark.5cb0146b.svg";